const c = ({
  value: a,
  inputMin: r = 0,
  inputMax: e = 100,
  outputMin: t = 0,
  outputMax: o = 255
}) => (a - r) / (e - r) * (o - t) + t, n = (a) => Math.max(Math.min(a * 255, 255), 0);
export {
  c as convertRange,
  n as opacityToAlpha
};
//# sourceMappingURL=index.es60.js.map
